import {makeStyles} from '@material-ui/core/styles'
import ApproverSearch from '../../2compounds/ApproverSearch'
import {useEffect, useState} from 'react'
import GroupCreateModalBase from '../../2compounds/GroupCreateModalBase'
import List from '@mui/material/List'
import UserListItem from '../../2compounds/UserListItem'

const SelectUsersModal = ({open, setOpen, users, setUsers, owner}) => {
    const classes = useStyles()
    const [usersTemp, setUsersTemp] = useState(null)
    const [usersListTemp, setUsersListTemp] = useState([])
    const selectedUsers = owner ? usersListTemp.concat(owner) : usersListTemp

    const cancelHandler = () => {
        setOpen(false)
    }

    const saveHandler = () => {
        setUsers(usersListTemp)
        setOpen(false)
    }

    const addUserHandler = (newValue) => {
        const copy = [...usersListTemp]
        copy.push(newValue)
        setUsersListTemp(copy)
        setUsersTemp(null)
    }

    const deleteHandler = (index) => {
        const copy = [...usersListTemp]
        copy.splice(index, 1)
        setUsersListTemp(copy)
    }

    useEffect(()=>{
        setUsersListTemp(users)
    }, [users, open])

    return (
        <GroupCreateModalBase header='Assign users'
                              saveHandler={saveHandler}
                              cancelHandler={cancelHandler}
                              open={open}
                              setOpen={setOpen}>
            <ApproverSearch approver={usersTemp} setApprover={addUserHandler} selectedUsers={selectedUsers} />
            <div className={classes.listDiv}>
                <List>
                    {
                        usersListTemp.map((user, index)=>(
                            <UserListItem
                                key={user.user_id || index}
                                user={user}
                                index={index}
                                deleteHandler={(index)=>deleteHandler(index)}
                            />
                        ))
                    }
                </List>
            </div>
        </GroupCreateModalBase>
    )
}

export default SelectUsersModal

const useStyles = makeStyles({
    root: {

    },
    listDiv: {
        height: '300px',
        overflowY: 'auto'
    }
})
